import React, { useEffect, useMemo } from "react";
import {
  createLocalContentRef,
  getContentPreviewUrl,
  isContentFileImage,
  normalizeContentFileFromApi,
} from "../../utils/ReusableFunctions";
import { FILE_STARTS_WITH } from "../../utils/Constant";

const ContentFileUploader = ({
  id,
  value = null,
  onChange = () => {},
  accept = "image/*,application/pdf",
  onRemove = () => {},
  label = null,
}) => {
  const normalizedValue = useMemo(
    () => normalizeContentFileFromApi(value),
    [value]
  );

  const handleFileChange = (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    onChange(createLocalContentRef(file));
  };

  const removeFile = (e) => {
    e.preventDefault();
    onChange(null);
    onRemove();
  };

  const fileUrl = useMemo(() => {
    if (!normalizedValue) return null;
    return getContentPreviewUrl(normalizedValue);
  }, [normalizedValue]);

  useEffect(() => {
    return () => {
      if (
        fileUrl &&
        normalizedValue?.file instanceof Blob &&
        fileUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl, normalizedValue]);

  if (!label && accept) {
    label = accept
      .split(",")
      .map((type) => type.trim())
      .map((type) => {
        const match = Object.keys(FILE_STARTS_WITH).find((prefix) =>
          type.startsWith(prefix)
        );
        return match ? FILE_STARTS_WITH[match] : null;
      })
      .filter(Boolean)
      .filter((v, i, arr) => arr.indexOf(v) === i)
      .join(", ");
    if (label) label = `Accepted file types: ${label}`;
    else label = `Accepted file types: ${accept}`;
  }

  return (
    <div className="img-form-group">
      <label className="form-label">Upload Content</label>

      {!normalizedValue ? (
        <div className="img-upload-wrapper">
          <input
            type="file"
            id={`carouselUpload${id}`}
            onChange={handleFileChange}
            accept={accept}
          />
          <label htmlFor={`carouselUpload${id}`}>
            <div className="primary-btn py-1 f-s-10 pointer">Upload</div>
            {label && (
              <p className="inter-regular f-s-8 lh-10 grey-757">{label}</p>
            )}
          </label>
        </div>
      ) : (
        <div className="selected-file">
          {isContentFileImage(normalizedValue) ? (
            <div className="image-preview">
              {fileUrl && (
                <img
                  src={fileUrl}
                  alt={normalizedValue?.name || "Content Image"}
                />
              )}
              <button type="button" className="pointer" onClick={removeFile}>
                ❌
              </button>
            </div>
          ) : (
            <div className="d-flex w-fit align-items-center justify-content-between">
              {fileUrl && (
                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                  <div className="primary-btn">View Content</div>
                </a>
              )}
              <span onClick={removeFile} className="pdf-close-icon">
                ❌
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContentFileUploader;
